import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslocoService } from '@jsverse/transloco';
import { AllergenEnum } from '@timechef/core/api';
import { RgpdCookiesService } from '@timechef/core/services/rgpd-cookies.service';
import { getEnumArray } from '@timechef/core/utils/array-utils';
import { AccountRepository } from '@timechef/features/account/state';
import { debounceTime } from 'rxjs';
import { Allergen } from 'src/app/features/restaurants/state/restaurants.models';

@Component({
  selector: 'app-parameters-modal',
  templateUrl: './parameters-modal.component.html',
  styleUrls: ['./parameters-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ParametersModalComponent implements OnInit {
  allergenItems: AllergenWithFormControl[] = [];

  rgpdCookiesService = inject(RgpdCookiesService);
  router = inject(Router);

  constructor(
    private modalCtrl: ModalController,
    private fb: FormBuilder,
    private transloco: TranslocoService,
    private accountRepo: AccountRepository,
  ) {}

  ngOnInit(): void {
    const userAllergens: AllergenEnum[] = this.accountRepo.getAllergens();

    this.allergenItems = getEnumArray<AllergenEnum>(AllergenEnum)
      .map((allergenEnum) => {
        const isSelected = userAllergens.includes(allergenEnum);

        const ctrl = this.fb.control(isSelected);
        ctrl.valueChanges.pipe(debounceTime(300)).subscribe((isChecked) => {
          this.accountRepo.updateAllergen(allergenEnum, !!isChecked);
        });
        return {
          enum: allergenEnum,
          label: this.transloco.translate('AllergenEnum.' + allergenEnum),
          svg: '/assets/svg/dish/allergens/' + allergenEnum.toString().toLowerCase() + '.svg',
          formControl: ctrl,
        };
      })
      .sort((a, b) => (a.label! < b.label! ? -1 : 1));
  }

  showCookiesConfig() {
    this.rgpdCookiesService.prompt({ isInitialPrompt: false });
  }

  showNotificationsConfig() {
    this.dismissModal();
    this.router.navigate(['account/notifications-settings']);
  }

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }
}

interface AllergenWithFormControl extends Allergen {
  formControl: FormControl;
}
